import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CareersService } from '../../services/careers/careers.service';

@Component({
	selector: 'app-list-careers',
	templateUrl: './list-careers.component.html',
	styleUrls: [ './list-careers.component.scss' ]
})
export class ListCareersComponent implements OnInit {
	careers: any;
	endpoint: any;

	constructor(private careersService: CareersService) {
		const t = this;
		t.endpoint = environment.endpoint;
		this.loadItems();
	}

	ngOnInit(): void {}

	loadItems() {
		const t = this;
		this.careersService.get().subscribe((data: any) => {
            t.careers = data;
            t.careers.sort((a: any, b: any) => {
				return <any>new Date(b.date) - <any>new Date(a.date);
			});
		});
	}

	setFilePath(fileUrl: any) {
		return this.endpoint + 'files/' + fileUrl.photo.path + '/download';
	}
}
